import axios from 'axios'
import { BASE_URL } from '@/config/api'

// 创建 axios 实例
const service = axios.create({
  baseURL: BASE_URL(),
  timeout: 0, // 设置为0表示无限超时
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*',
    'Accept-Encoding': 'gzip, deflate, br',
    'Connection': 'keep-alive',
    'User-Agent': 'PostmanRuntime-ApipostRuntime/1.1.0'
  }
})

// request 拦截器
service.interceptors.request.use(
  config => {
    // 在发送请求之前做些什么
    // 注入 token 请求头
    const token = localStorage.getItem('bankflow_token')
    if (token) {
      config.headers['token'] = token
    }
    return config
  },
  error => {
    // 对请求错误做些什么
    console.log(error)
    return Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 1) {
      return res
    } else if (res.code === 401) {
      // 处理未授权的情况：清除 token 并跳转登录页
      localStorage.removeItem('bankflow_token')
      // 动态 require router 避免循环依赖
      const router = require('@/router').default
      router.replace({
        path: '/login',
        query: { redirect: router.currentRoute.fullPath }
      })
      return Promise.reject(new Error('未授权或登录已过期'))
    } else {
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    // 仅记录错误消息，避免打印含敏感信息（如登录密码）的 error.config
    console.error('请求错误:', error.message)
    return Promise.reject(error)
  }
)

export default service 